const isStaging =
  import.meta.env.VITE_DEV_STAGING ||
  window.location.href === 'https://staging.app.pasta.to'
export default isStaging
